import { mean, type MathArray } from "mathjs";
import type {
  NumberMatrix,
  NumberMatrix3D,
  SimpleDataCharts,
} from "../algorithm.types";

export default function calculateSimpleAverageCharts(
  dayChartData: NumberMatrix3D,
): SimpleDataCharts {
  const nonDroughtSource: NumberMatrix3D = [...dayChartData];

  const droughtSource: Array<NumberMatrix3D> = [];
  droughtSource.push(nonDroughtSource.splice(3, 1));
  droughtSource.push(nonDroughtSource.splice(6, 1));

  // mathjs `mean` averages element-wise along dimension 0; its public type is
  // too narrow for these deeply nested arrays, so cast at the library boundary.
  const droughtAveraged = mean(
    droughtSource as unknown as MathArray,
    0,
  ) as NumberMatrix3D;
  const nonDroughtAverageData = mean(
    nonDroughtSource as unknown as MathArray,
    0,
  ) as NumberMatrix;

  return {
    droughtAverageData: droughtAveraged[0],
    nonDroughtAverageData,
  };
}
